import React from "react";
import "../style/page/StaticNotice.css";
import { useTranslation } from "../contexts/TranslationContext";

function Privacy() {
  const { currentLanguage } = useTranslation();

  const title = currentLanguage === "en" ? "Privacy Policy" : "Chính sách bảo mật";
  const message =
    currentLanguage === "en"
      ? "We are currently updating this content, so you are limited; we sincerely apologize for any inconvenience this may cause."
      : "Hiện tại chúng tôi đang cập nhật nội dung này, vì vậy bạn sẽ bị hạn chế truy cập; chúng tôi thành thật xin lỗi vì bất kỳ sự bất tiện nào mà điều này có thể gây ra.";

  return (
    <main className="main-content static-notice-page">
      <h4 className="page-title">{title}</h4>
      <div className="static-notice-card">
        <p>{message}</p>
      </div>
    </main>
  );
}

export default Privacy;
